import React, { createContext, FC } from "react";
import { ScreenProps } from "../../typings";
import { DashboardView as IDashboardView } from "@data-root/types";
import { DesktopDashboardView } from "./desktop";
import { TinyEmitter } from "tiny-emitter";
import { useClientContext } from "@data-root/react";
import { MobileDashboardView } from "./mobile";

export interface IDashboardContext {
  emitter: TinyEmitter;
}

export const DashboardContext = createContext<IDashboardContext | undefined>(
  undefined
);

export const DashboardView: FC<ScreenProps<IDashboardView>> = (props) => {
  const { desktop } = useClientContext();

  return desktop ? (
    <DesktopDashboardView {...props} />
  ) : (
    <MobileDashboardView {...props} />
  );
};
